import { render } from "./stylistForm.vue?vue&type=template&id=596f5d3b&scoped=true"
import script from "./stylistForm.vue?vue&type=script&lang=js"
export * from "./stylistForm.vue?vue&type=script&lang=js"

import "./stylistForm.vue?vue&type=style&index=0&id=596f5d3b&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596f5d3b"]])

export default __exports__